export const copilotApiEndpoint =
  process.env.REACT_APP_COPILOT_API_URL || "https://copilot.ge3s.org/api/chat";
export const copilotSourcesEndpoint =
  process.env.REACT_APP_COPILOT_SOURCES_URL ||
  "https://copilot.ge3s.org/api/sources";
